import { Outlet, createFileRoute } from "@tanstack/react-router";

import MarketingFooter from "@/components/marketing/MarketingFooter";
import MarketingHeader from "@/components/marketing/MarketingHeader";
import MarketingShell from "@/components/marketing/MarketingShell";
import { useNotFoundBelow } from "@/components/marketing/useNotFoundBelow";

/**
 * The chrome the country pages share; their 404 is the site's, drawn without
 * it.
 *
 * A sibling of `_app` rather than a child: these pages are public, and `_app`'s
 * `RouteGuard` bounces an anonymous visitor to sign-in.
 */
export const Route = createFileRoute("/proxy-locations")({
  component: ProxyLocationsLayout,
});

function ProxyLocationsLayout() {
  if (useNotFoundBelow()) {
    return (
      <MarketingShell>
        <Outlet />
      </MarketingShell>
    );
  }
  return (
    <MarketingShell>
      <MarketingHeader />
      {/* No clearance for the fixed bar here: each page carries its own. */}
      <Outlet />
      <MarketingFooter />
    </MarketingShell>
  );
}
